import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tokens.css';
import './styles/shared.css';
import App from './App';

// Mode nuit (2026-09-30, comme A97 BI) : appliqué AVANT le premier rendu ;
// choix mémorisé dans le navigateur, sinon réglage du système.
try {
  const t = localStorage.getItem('data-theme')
    || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  document.documentElement.dataset.theme = t;
} catch (e) { document.documentElement.dataset.theme = 'light'; }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
